// CONSTANTS are all caps.
const NS = 'BrandNavigation';
const CLS = 'brandNavigation';
const BLK = '.' + CLS + '-';

// Import stuff here if you need to or even better to import them dynamically
// for ex. of dynamic import check out ./loadBlk.js using Webpack dynamic imports as chunks.
// import $ from 'jquery'
import * as utils from '../../../../global/js/utils';


export class BrandNavigation {
	constructor($el) {
		// $el is the blk node return by the loadBrandNavigation function
		this.$el = $el;
	}

	init() {
		this.setBrandNavigation();
	}

	setBrandNavigation() {
		// Add Some logic here
		let $this = $(this.$el);
		let $navItem = $this.find(`${BLK}navItem`);
		let indexActive = $this.find(`${BLK}navItem.active`).index();

		function showSubmenu(element) {
			if (element.hasClass('has-dropdown')) {
				element.find('.dropdown-menu').css('display', 'block');
				element.find('.dropdown-menu li').animate({
					opacity: '1',
				}, 0);
			}
		}
		function hideSubmenu(element) {
			element.find('.dropdown-menu').css('display', 'none');
			element.find('.dropdown-menu li').css('opacity', '0');
		}
		$navItem.on('click', function(e) {
			$navItem.removeClass('active');
			$(this).addClass('active');
			hideSubmenu($navItem);
			showSubmenu($(this));
			indexActive = $(this).index();
		});
		$navItem.hover(
			function() {
				if (!utils.isOnMobile()) {
					$navItem.removeClass('active');
					hideSubmenu($navItem);
					$(this).addClass('active');
					showSubmenu($(this));
				}
			},
			function() {
				if (!utils.isOnMobile()) {
					$(this).removeClass('active');
					hideSubmenu($(this));
					$navItem.eq(indexActive).addClass('active');
					showSubmenu($navItem.eq(indexActive));
				}
			}
		);

		$this.on('mouseleave', `.${CLS}-navList`, function() {
			if (!utils.isOnMobile()) {
				$this.find('.dropdown-menu').css('display', 'none');
				$this.find(`.${CLS}-navItem.active`).removeClass('active');
			}
		});
	}

	// Add more functions like on above here
}



// WEBPACK FOOTER //
// D:/AzureDevops/vsts-agent-win-x64-2.202.1_04/_work/396/s/FrontEnd/src/views/blocks/brandNavigation/js/brandNavigation.js